<template lang='pug'>
div
  Dialog(
    v-if='shouldShowDialog'
    :key='shouldShowDialogTimestamp'
  )
    slot(
      name='dialog'
    )
  slot(
    :shouldShowDialogUpdate='shouldShowDialogUpdate'
  )
</template>

<script>
import Dialog from './Dialog.vue';

import { useEventToProp } from '../functions/useEventToProp';

const setup = () =>
{
  const { prop: shouldShowDialog, propUpdate: shouldShowDialogUpdate, timestamp: shouldShowDialogTimestamp } = useEventToProp();

  return {
    shouldShowDialog,
    shouldShowDialogUpdate,
    shouldShowDialogTimestamp,
  };
};

export default
{
  components:
  {
    Dialog,
  },
  setup,
};
</script>